<template>
    <div id="app">
        <router-view />
        <div class="tip" v-if="shouldShowTips">
            <TipsLayer></TipsLayer>
        </div>
    </div>
</template>
<script>
import { getUuid } from '@/api/index'
import TipsLayer from '@/components/layer/TipsLayer.vue'
export default {
    components: {
        TipsLayer
    },
    computed: {
        // 计算属性：判断当前路由是否需要显示 TipsLayer
        shouldShowTips() {
            // 需要隐藏 TipsLayer 的路由规则（包含动态路由和通配符路由）
            const hiddenRoutePatterns = [
                '/login',
                '/about',
                '/credit/:userId/:classId', // 带参数的动态路由规则
                '/ah/:id', // 新增：匹配所有以 /course 开头的路由
                '/learning' // 学习中心页面不显示 TipsLayer
            ];

            // 检查当前路由是否匹配隐藏规则中的任何一个
            return !hiddenRoutePatterns.some(pattern => {
                // 处理带通配符*的模式（匹配前缀）
                if (pattern.endsWith('*')) {
                    const prefix = pattern.slice(0, -1); // 移除*
                    return this.$route.matched.some(route =>
                        route.path.startsWith(prefix)
                    );
                }
                // 处理普通路由和动态参数路由（精确匹配）
                return this.$route.matched.some(route =>
                    route.path === pattern
                );
            });
        }
    },
    created() {
        this.isWx();
        this.getData();
        // this.checkMobileRedirect(); // 新增：检查移动端并跳转
    },
    mounted() {
        //window.addEventListener('keydown', this.disableF12);
    },
    beforeDestroy() {
        // 移除事件监听器以避免内存泄漏
        window.removeEventListener('keydown', this.disableF12);
    },
    methods: {
        disableF12(event) {
            if (event.key === 'F12') {
                event.preventDefault();
            }
        },
        getData() {
            getUuid().then(res => {
                this.$store.commit('SET_UUID', res.uuid)
            })
        },
        isWx() {
            var ua = window.navigator.userAgent.toLowerCase();
            // if(ua.match(/MicroMessenger/i) == 'micromessenger'){ 
            //     sessionStorage.setItem('isWx','true');
            // }else{ 
            //     sessionStorage.setItem('isWx','false');
            // }
        },
        // 在组件的方法中（如 checkMobileRedirect）
        getVueRoutePath() {
            const currentRoute = this.$router.currentRoute; // 获取当前路由对象

            console.log("Vue 路由路径（不含查询参数）:", currentRoute.path); // 输出：/credit/123/456
            console.log("Vue 完整路由路径（含查询参数）:", currentRoute.fullPath); // 输出：/credit/123/456?a=1
            console.log("路由动态参数:", currentRoute.params); // 输出：{ userId: '123', classId: '456' }
        },
        // 新增：判断是否移动端并跳转微信链接
        checkMobileRedirect() {
            const currentPath = this.getVueRoutePath()

            const excludeRouteRegex = /^\/credit\/[^\/]+\/[^\/]+$/;

            // 3. 检查：若当前路径是排除路由 → 不执行重定向
            if (excludeRouteRegex.test(currentPath)) {
                console.log("当前路径是排除路由，不跳转");
                return;
            }
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            if (isMobile) {
                window.location.href = 'weixin://dl/business/?t=JsqiX768Odn';
            }
        }
    }
}
</script>

<style>
#app {
    z-index: 999;
    /* font-family: Avenir, Helvetica, Arial, sans-serif; */
    /* -webkit-font-smoothing: antialiased; */
    /* -moz-osx-font-smoothing: grayscale; */
    /* text-align: center; */
    /* color: #2c3e50; */

    .app {
        min-height: 100vh !important;
    }

    &>.tip {
        position: fixed;
        right: 20px;
        bottom: 28px;
        z-index: 999;
    }
}
</style>